import React from 'react'
import PropTypes from 'prop-types'
import Media from 'sb-media'
import { useMemo } from 'sb-hooks'
import { connect } from 'redaction'
import { links, compose } from 'common/helpers'
import cx from 'classnames'

import injectGlobals from 'decorators/injectGlobals'

import Link from 'components/ui/Link/Link'

import SearchBanner from '../SearchBanner/SearchBanner'

import messages from './messages'
import s from './SearchSuggestions.scss'


const getSuggestions = (gender, isMobile) => {
  const isMale = gender === 'male'

  if (isMobile) {
    return [
      {
        title: messages.collections.mobile[gender],
        link: isMale ? links.subscription.collectionsMen : links.subscription.collectionsWomen,
        type: 'collections',
      },
      {
        title: messages.bestsellers,
        link: links.subscription.bestsellers,
        type: 'bestsellers',
      },
      {
        title: messages.besidesFragrances.mobile[gender],
        link: isMale ? links.candles : links.makeupPalettes,
        type: isMale ? 'candles' : 'palettes',
      },
    ]
  }

  return [
    {
      title: messages.collections.desktop,
      link: isMale ? links.subscription.collectionsMen : links.subscription.collectionsWomen,
      type: 'collections',
    },
    {
      title: messages.bestsellers,
      link: links.subscription.bestsellers,
      type: 'bestsellers',
    },
    {
      title: messages.besidesFragrances.desktop[gender],
      link: isMale ? links.candles : links.makeupPalettes,
      type: isMale ? 'candles' : 'palettes',
    },
    {
      title: isMale ? messages.quiz : messages.allMakeup,
      link: isMale ? links.quizMen : links.makeup,
      type: isMale ? 'quiz' : 'makeup',
    },
  ]
}

const SearchSuggestions = (props) => {
  const { className, gender, isMobile, handleSuggestionClick, controlsId, descendantId } = props

  const suggestions = useMemo(
    () => getSuggestions(gender, isMobile),
    [ gender, isMobile ]
  )

  return (
    <div
      id={controlsId}
      className={cx(s.container, className)}
      onClick={(event) => event.stopPropagation()}
      role="listbox"
      tabIndex="-1"
    >
      <div className={s.linkList}>
        {
          suggestions.map(({ title, link, type }, index) => (
            <Link
              key={type}
              id={`${descendantId}_${index}`}
              className={cx(s.itemLink, s.suggestion)}
              title={title}
              to={link}
              role="option"
              blackColor
              withHtmlTitle
              tabIndex={index === 0 ? 0 : -1}
              onClick={() => {
                handleSuggestionClick({
                  suggestionType: type,
                  position: index + 1,
                })
              }}
            />
          ))
        }
      </div>
      <Media desktop>
        <SearchBanner
          id={`${descendantId}_${suggestions.length}`}
          className={s.banner}
          gender={gender}
          role="option"
          tabIndex={-1}
          onClick={() => {
            handleSuggestionClick({
              suggestionType: 'banner',
            })
          }}
        />
      </Media>
    </div>
  )
}

SearchSuggestions.propTypes = {
  className: PropTypes.string,
  gender: PropTypes.oneOf([ 'male', 'female' ]),
  handleSuggestionClick: PropTypes.func,
  controlsId: PropTypes.string,
  descendantId: PropTypes.string,

  // @injectGlobals
  isMobile: PropTypes.bool,
}


export default compose(
  injectGlobals(({ globals }) => ({
    isMobile: globals.device.isMobile,
  })),
  connect({
    gender: 'models.me.gender',
  }),
)(SearchSuggestions)
